import { sendFacetTransaction } from "./sendFacetTransaction";
export const walletL1FacetActions = (l1WalletClient) => ({
    sendFacetTransaction: (params) => sendFacetTransaction(l1WalletClient, params),
});
